module.exports = __webpack_public_path__ + "img/logo-defi-ville-intelligente.2e66695f.png";